import React, { useState } from "react";

export let financeHeaderValue = {
  "HV Amount": "homeVisitAmount",
  "Insurer's Amount": "insurerAmount",
  "Additional Tests":"additionalTest",
  "Test Details":"tests",
  "Package":"package",
  "TDS":"tds",
  "Provider Amount":"providerAmount",
  "Photograph Amount":"photographAmount",
  "Split Amount":"splitIndividualTestAmount",
  "Docket No":"docketNo",
  "Case No":"caseNo",
  "Pay ID":"payReceipt",
  "Customer Name":"proposerName",
  "Finance Amount":"financeAmount",
  "Finance HV Amount":"financeHVAmount",
  "Remarks":"remarks",
  "GST":"gst",
  "Receipt ID":"payReceipt",
  "Insurer Amount":"insurerAmount",
  "Service Charge":"serviceCharge",
  "Discount Type":"discountType",
  "Discount %":"discountPercentage",
  "Discount Amount":"discountedAmount"
};
export const AdditionalFinanceApptHeader = ({ rowData,header, setHeader }) => {
  const TableHeader = [
    "Pay ID",
    "Customer Name",
    "Provider Amount",
    "HV Amount",
    // "TDS",
    // "Insurer Amount",
    "Test Details",
    "Additional Tests",
    "Package",
    "Photograph Amount",
    "Split Amount",
    "Docket No",
    "Case No",
    "Remarks",
    "Discount Type",
    "Discount %",
    "Discount Amount"
  ];
  const InsTableHeader = [
    "Receipt ID",
    "Customer Name",
    "Insurer Amount",
    "HV Amount",
    // "GST",
    // "Service Charge",
    // "Insurer Amount",
    "Adjustment Amount",
    "Test Details",
    "Additional Tests",
    "Package",
    "Docket No",
    "Remarks"
  ];

  return (
    <div class="modal-dialog modal-dialog-centered " role="document">
      <div class="modal-content">
        <div
          className="d-flex justify-content-between border-bottom modalHeader"
          style={{ borderRadius: "10px 10px 0px 0px" }}
        >
          <h4 className="font-bold text-black">Choose To Filter Table</h4>
          <button
            type="button"
            className="btn-close history-close"
            aria-label="Close"
            data-bs-dismiss="modal"
          ></button>
        </div>
        {(rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC") && <div className="modal-body " style={{padding:"0 30px"}}>
          <div className="select-time-interval" style={{ height: "500px",overflowY: "auto" }}>
            {TableHeader?.map((ele, index) => (
              <div className="d-flex gap-3">
                <div style={{ fontSize: "15px"}}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={header?.some((element) => element === ele)}
                    onClick={(e) => {
                      if (e.target.checked) {
                        setHeader([...header, ele]);
                      }else{
                        let arr = header.filter(item=>item !== ele)
                        setHeader(arr)
                      }
                    }}
                  />
                </div>
                <label style={{ fontSize: "13px", padding: "3px" }}>
                  {ele}
                </label>
              </div>
            ))}
          </div>
        </div>}
        
        {rowData?.detailType ==="InsurerBillingQC" && <div className="modal-body " style={{padding:"0 30px"}}>
          <div className="select-time-interval" style={{ height: "100%" }}>
            {InsTableHeader?.map((ele, index) => (
              <div className="d-flex gap-3">
                <div style={{ fontSize: "15px", padding: "3px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={header?.some((element) => element === ele)}
                    onClick={(e) => {
                      if (e.target.checked) {
                        setHeader([...header, ele]);
                      }else{
                        let arr = header.filter(item=>item !== ele)
                        setHeader(arr)
                      }
                    }}
                  />
                </div>
                <label style={{ fontSize: "13px", padding: "3px" }}>
                  {ele}
                </label>
              </div>
            ))}
          </div>
        </div>}
        <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0 ">
          <div>
            <input
              type="checkbox"
              className="form-check-input"
              onClick={(e) => {
                e.target.checked
                  ? setHeader(rowData?.detailType ==="InsurerBillingQC" ? InsTableHeader:TableHeader)
                  : setHeader([]);
              }}
              checked={
                header?.length === TableHeader.length || header?.length === InsTableHeader?.length
              }
            />
            <label
              className="margin-right"
              style={{ marginLeft: "10px", fontWeight: "600" }}
            >
              Select All
            </label>
          </div>
          <div>
            <button
              type="button"
              className="savedetails"
              aria-label="Close"
              data-bs-dismiss="modal"
              onClick={() => {
              }}
            >
              Show Selected
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
